import React, { useContext, Fragment } from 'react';
import { withStyles, Divider, Grid } from '@material-ui/core';
import Carousel from '../../carousel/Carousel';
import DataContext from '../../data/DataContext';
import { openLink } from '../../util/utilNative';
import IconMore from '../../../asset/img/btn_more_nor.svg';
import IconInfo from '../../../asset/img/ico_info_black.svg';
import IconCons from '../../../asset/img/footer_ico_consulting.svg';
import IconConsStore from '../../../asset/img/footer_ico_consulting_store.svg';
import IconConsDis from '../../../asset/img/footer_ico_consulting_disable.svg';
import IconConsStoreDis from '../../../asset/img/footer_ico_consulting_store_disable.svg';
import IconExpert from '../../../asset/img/Icon_menu_purchasing_expert.svg';
import IconManual from '../../../asset/img/Icon_menu_guidebook.svg';
import IconStory from '../../../asset/img/Icon_menu_story.svg';

// import IconMorePressed from "../../../asset/img/btn_more_sel.png";
// import IconBadge from "../../../asset/img/ico_flag_newProd.png";

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.0313rem',
    margin: '0.375rem 0rem',
    zIndex: 10,
  },
  carousel: {
    width: '100%',
    height: '9rem',
  },
  listitem: {
    width: '16.625rem',
    padding: '0px',
    display: 'flex',
    margin: '0 0 0.375rem 0',
  },
  card: {
    width: '16.25rem',
    height: '100%',
    flex: 'auto',
    background: '#fff',
    border: '0.0625rem solid #d7d7d7',
    borderRadius: '0.375rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 0.375rem 0 0',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1)',
    position: 'relative',
  },
  badgeBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // margin: "12px"
  },
  badgeItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '1.25rem',
    borderRadius: '0.25rem',
    fontWeight: 'bold',
    fontSize: theme.font.size11,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1',
    letterSpacing: 'normal',
    margin: '0 0.25rem 0 0',
    padding: '0 0.375rem',
    width: 'max-content',
  },
  badgeItemRed: {
    background: theme.color.badge.bg_red,
    color: theme.color.badge.text_red,
  },
  badgeItemPupple: {
    background: theme.color.badge.bg_pupple,
    color: theme.color.badge.text_pupple,
  },
  badgeItemGreen: {
    background: theme.color.badge.bg_green,
    color: theme.color.badge.text_green,
  },
  badgeItemGrey: {
    background: theme.color.badge.bg_grey,
    color: theme.color.badge.text_grey,
  },
  badgeItemDefault: {
    border: 'solid 1px #f6f6f6',
  },
  moreItemList: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '18.75rem',
    padding: '0rem 0rem 0rem 0.5rem',
  },
  moreItemCard: {
    width: '140px',
    background: 'transparent',
    border: '0px',
    borderRadius: '0.375rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  moreItemText: {
    fontSize: theme.font.size13,
    fontWeight: 'normal',
    color: theme.color.text,
    textAlign: 'center',
    margin: '0.9375rem 0rem',
    lineHeight: '1.46',
  },
  thumbnail: {
    minHeight: '9.75rem',
    padding: '1rem 0 0 0',
    margin: '1rem 0 0 0',
    background: 'none',
    border: 'none',
  },
  thumbnailImage: {
    width: 'auto',
    height: '140px',
  },
  moreItemThumbnailImage: {
    width: '3.75rem',
    height: '3.75rem',
    backgroundImage: `url(${IconMore})`,
    backgroundSize: '3.75rem',
    // "&:active": {
    //   backgroundImage: `url(${IconMorePressed})`,
    // },
  },
  info: {
    flexGrow: 1,
    minHeight: '9.688rem',
  },
  infoTitle: {
    display: 'flex',
    justifyContent: 'flex-start',
    fontSize: theme.font.size16, // "15px",
    fontWeight: 'bold',
    color: theme.color.text_color.black,
    textAlign: 'left',
    padding: '0rem 1.25rem',
    minHeight: '2.875rem',
    lineHeight: '1.38',
  },
  infoDescription: {
    display: 'flex',
    justifyContent: 'flex-start',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    color: theme.color.text_color.grey,
    padding: '0rem 1.25rem',
    // margin: "0 0 12.5px 0"
    // textAlign: "center",
  },
  horizontalDivider: {
    width: 'auto',
    height: '0.0625rem',
    backgroundColor: theme.color.divider.grey,
    margin: '0.7188rem 1.25rem',
  },
  table: {
    width: '-webkit-fill-available',
    margin: '0 1.25rem',
    padding: '0px',
  },
  tableRow: {
    height: '100%',
    display: 'flex',
    alignItems: 'baseline',
  },
  label: {
    height: '100%',
    minHeight: '2rem',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    color: theme.color.text_color.grey,
    textAlign: 'left',
    lineHeight: '1.08',
    padding: '0 0.25rem 0 0',
    display: 'flex',
    alignItems: 'center',
  },
  value: {
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    color: theme.color.text_color.black,
    textAlign: 'right',
    padding: '0 0 0 0.25rem',
    textOverflow: 'ellipsis',
    // display: "flex",
    // alignItems: "flex-end",
    lineHeight: '1.08',
    // wordBreak: "keep-all"
  },
  external: {
    display: 'flex',
    minHeight: '2.813rem',
    // borderRadius: "0px 0px 12px 12px",
    background: '#fafafa',
  },
  externalHorizontal: {
    display: 'flex',
    minHeight: '2.5rem',
    background: theme.color.button.background_white,
    flexDirection: 'row',
    padding: '0 1rem',
    borderRadius: '0.375rem',
    margin: '0 0 1rem 0',
  },
  endBorderRadius: {
    borderRadius: '0 0 0.75rem 0.75rem',
  },
  externalButtonLeft: {
    borderRadius: '0rem 0rem 0rem 0.75rem',
  },
  externalButtonRight: {
    borderRadius: '0rem 0rem 0.75rem 0rem',
  },
  horizontalButton: {
    width: '100%',
    height: '2.8125rem',
    textAlign: 'center',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    padding: '0rem',
    borderRadius: '0.375rem',
    border: '0rem',
  },
  horizontalButtonGrey: {
    color: theme.color.button.text_black,
    backgroundColor: theme.color.button.background_grey,
  },
  horizontalButtonRed: {
    color: theme.color.button.text_white,
    backgroundColor: theme.color.button.background_red,
  },
  horizontalButtonMore: {
    margin: '0 0 0 0.3125rem',
    color: theme.color.button.text_black,
    backgroundColor: theme.color.button.background_grey,
  },
  horizontalButtonLast: {
    margin: '0 0 0 0.3125rem',
    color: theme.color.button.text_white,
    backgroundColor: theme.color.button.background_red,
  },
  disabledWhiteButton: {
    color: theme.color.button.wbut_text_disable,
    backgroundColor: theme.color.button.wbut_bg_disable,
    // border: `solid 1px ${theme.color.button.wbut_border_disable}`
  },
  disabledRedButton: {
    // color: "rgba(38, 38, 38, 0.4)",
    backgroundColor: theme.color.button.background_red_disable,
    color: theme.color.button.text_white_disable,
  },
  externalDivider: {
    // height: "20px",
    alignSelf: 'center',
    backgroundColor: theme.color.divider,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  buttonIcon: {
    width: '1.25rem',
    height: '1.25rem',
    marginRight: '0.25rem',
  },
  horizontalButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0.5rem 1.125rem',
  },
  horizontalButtonLabel: {
    display: 'flex',
    flexDirection: 'row',
  },
  priceBox: {
    width: '-webkit-fill-available',
    margin: '0 1.25rem',
    padding: '0.625rem 0',
  },
  priceRow: {
    height: '100%',
    display: 'flex',
    alignItems: 'baseline',
  },
  discountRate: {
    color: theme.color.text_color.red,
    fontSize: theme.font.size16,
    fontWeight: 'bold',
    marginRight: '0.25rem',
    lineHeight: 1.13,
    letterSpacing: 'normal',
    // marginStart: "0.5rem",
  },
  discountRateDisable: {
    color: theme.color.text_color.price_na,
  },
  priceObs: {
    fontWeight: 'bold',
    fontSize: theme.font.size16,
    color: theme.color.text_color.black,
    // marginStart: "8px",
    wordBreak: 'breakWord',
    lineHeight: '1.13',
  },
  priceObsNA: {
    color: theme.color.text_color.price_na,
  },
  priceMaster: {
    textDecoration: 'line-through',
    fontSize: theme.font.size14,
    color: theme.color.message.grey,
    textDecorationColor: theme.color.message.grey,
    marginStart: '0.5rem',
  },
  maxBenefitPrice: {
    fontSize: theme.font.size11,
    fontWeight: 'normal',
    lineHeight: 1.18,
    letterSpacing: 'normal',
    color: '#000',
    textAlign: 'left',
    marginTop: '0.125rem',
  },
  badge: {
    position: 'absolute',
    margin: '0.75rem',
    display: 'flex',
  },
  badgeIcon: {
    height: theme.font.size35,
  },
  badgeTitle: {
    color: '#ffffff',
    position: 'absolute',
    fontSize: theme.font.size13,
    fontWeight: 'bold',
    margin: '0.3125rem 0.625rem',
  },
  benefitsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    // padding: "0 20px"
  },
  emptyBenefitsRow: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '1.1563rem',
    // minHeight: "100px"
  },
  benefitsText: {
    fontSize: theme.font.size11,
    color: theme.color.text_color.black,
    lineHeight: '1.18',
    textAlign: 'left',
    alignItems: 'center',
  },
  benefitsInfoButton: {
    minWidth: '1rem',
    minHeight: '1rem',
    // objectFit: "contain",
    backgroundImage: `url(${IconInfo})`,
    backgroundColor: 'transparent',
    border: '0rem',
  },
  midButtonRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    padding: '0 1.25rem 1.25rem 1.25rem',
    minHeight: '2.875rem',
  },
  midButtonBox: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: '1',
    alignItems: 'center',
    justifyContent: 'space-around',
    border: '0rem',
    backgroundColor: theme.color.button.background_white,
    padding: '0',
    minHeight: '2.875rem',
  },
  midButtonAdditional: {
    border: '0px',
    backgroundColor: theme.color.button.background_white,
    padding: '0',
  },
  midButtonAdditionalOnly: {
    margin: '0 0 1.875rem 1rem',
  },
  midButtonText: {
    fontSize: theme.font.size12,
    color: theme.color.text_color.black,
    lineHeight: '1.25',
    margin: '0.3125rem 0 0 0',
  },
  midButtonTextDisable: {
    fontSize: theme.font.size12,
    color: '#aaa',
    lineHeight: '1.25',
    margin: '0.3125rem 0 0 0',
  },
  midButtonTextAdditional: {
    textDecoration: 'underline',
    fontSize: theme.font.size12,
    color: theme.color.text_color.black,
    lineHeight: '1.33',
  },
  midButtonRowAddOnly: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    minHeight: '2.875rem',
    padding: '0 1.25rem 1.25rem 1.25rem',
  },
});

function MidButtonRaw(props) {
  const { classes, data, handleClick } = props;
  const context = useContext(DataContext);
  const item = data;
  // const enabledButtonCount = item.buttons.filter(button=>(button?.parameters?.enable==="Y"||!('enable' in button.parameters))).length;
  return (
    // (item.buttons && item.buttons.length>0 && enabledButtonCount > 0)?(
    item.buttons && item.buttons.length > 0 ? (
      <div className={[classes.midButtonRow].join(' ')}>
        {item.buttons.map((button, index) => {
          const isDisabled = context.conversationEnd || button.parameters.enable === 'N';
          let buttonIcon = '';
          switch (button.icon_code) {
            case 'expect_consulting':
              buttonIcon = IconExpert;
              break;
            case 'manual':
              buttonIcon = IconManual;
              break;
            case 'story':
              buttonIcon = IconStory;
              break;
          }

          return (
            <Fragment key={`buttons${index}`}>
              <Divider
                className={classes.externalDivider}
                orientation="vertical"
                hidden={index === 0}
                component={'div'}
                disabled
              />
              <button
                type="button"
                className={[classes.midButtonBox].join(' ')}
                disabled={isDisabled}
                onClick={() =>
                  handleClick(
                    context.userAgent.deviceType === 'mobile'
                      ? button.parameters?.mobile_url
                      : button.parameters?.url,
                    button.type,
                    button.speech,
                    button?.event_action,
                    button?.expect && button?.parameters,
                    button?.expect
                  )
                }
                aria-label={`${
                  button.type.toLowerCase() === 'external'
                    ? context.string.aria.external + ','
                    : ''
                } ${button.label}, ${item.link['product_title']
                  .replace('<sup>', '')
                  .replace('</sup>', '')
                  .replace('ThinQ', '씽큐')}, ${item.link['product_name']}`}
              >
                {/* <img src={(button.icon_code === "store_consulting" ? IconConsStore : IconCons)} /> */}

                <img src={buttonIcon} alt="" />
                <div
                  className={`${
                    isDisabled ? classes.midButtonTextDisable : classes.midButtonText
                  }`}
                >
                  {button.label}
                </div>
              </button>
            </Fragment>
          );
        })}

        {/* {(item.additional_link && item.additional_link.length>0)&&(
          <Fragment>
            <Divider
              className={classes.externalDivider}
              orientation="vertical"
              hidden={item.buttons.length === 0 || item.additional_link.length === 0}
              component={"div"}
              disabled
            />
            <div className={[
                classes.midButtonBox,
                // classes.midButtonTextAdditional
              ].join(" ")}>
                {
                  item.additional_link.map((linkItem, linkIndex)=>{
                    return (
                      <button 
                        key={`addlinkbtn-${linkIndex}`}
                        className={[classes.midButtonAdditional,classes.midButtonTextAdditional].join(" ")}
                        onClick={()=>handleClick(
                          context.userAgent.deviceType === "mobile"
                          ? linkItem.parameters?.mobile_url
                          : linkItem.parameters?.url, 
                          linkItem.type, 
                          linkItem?.speech, 
                          linkItem?.event_action, 
                          linkItem?.parameters,
                          linkItem?.expect
                          )}
                      >
                        {linkItem.label}
                      </button>)
                  })
                }
            </div>
          </Fragment>
        )} */}
      </div>
    ) : (
      <div className={classes.midButtonRowAddOnly}>
        {item.additional_link.map((linkItem, linkIndex) => {
          return (
            <button
              key={`addlinkbnt-${linkIndex}`}
              className={[
                classes.midButtonAdditional,
                classes.midButtonTextAdditional,
                classes.midButtonAdditionalOnly,
              ].join(' ')}
              onClick={() =>
                handleClick(
                  context.userAgent.deviceType === 'mobile'
                    ? linkItem.parameters?.mobile_url
                    : linkItem.parameters?.url,
                  linkItem.type,
                  linkItem?.speech,
                  linkItem?.event_action,
                  linkItem?.parameters,
                  linkItem?.expect
                )
              }
            >
              {linkItem.label}
            </button>
          );
        })}
      </div>
    )
  );
}
function HorizontalButtonRaw(props) {
  const { classes, data, handleClick } = props;
  const context = useContext(DataContext);
  const item = data;
  return (
    <div
      className={[
        classes.externalHorizontal,
        // classes.endBorderRadius,
      ].join(' ')}
    >
      {item.horizontal_buttons.map((button, index) => (
        <Fragment key={`horizontal_buttons${index}`}>
          {/* <Divider component={"div"} disabled /> */}
          <button
            type="button"
            className={[
              classes.horizontalButton,
              item.horizontal_buttons.length === 1
                ? classes.horizontalButtonRed
                : index === 0
                ? classes.horizontalButtonGrey
                : index === item.horizontal_buttons.length - 1
                ? classes.horizontalButtonLast
                : classes.horizontalButtonMore,

              // classes.endBorderRadius,
              button.parameters.enable === 'N' &&
                (index === 0 ? classes.disabledWhiteButton : classes.disabledRedButton),
            ].join(' ')}
            disabled={context.conversationEnd || button.parameters.enable === 'N'}
            onClick={() =>
              handleClick(
                context.userAgent.deviceType === 'mobile'
                  ? button.parameters?.mobile_url
                  : button.parameters?.url,
                button.type,
                button?.speech,
                button?.event_action,
                button?.expect && button?.parameters,
                button?.expect
              )
            }
          >
            {/* <div className={classes.horizontalButtonContainer}> */}
            {/* <div className={classes.horizontalButtonLabel}> */}
            {/* {button.label === context.string.chat.moreProducts && (
                  <img
                    className={classes.buttonIcon}
                    src={IconMore}
                    alt={"IconMore"}
                  />
                )} */}
            <div>{button.label}</div>
            {/* </div> */}
            {/* </div> */}
          </button>
        </Fragment>
      ))}
    </div>
  );
}

const MidButton = withStyles(styles)(MidButtonRaw);
const HorizontalButton = withStyles(styles)(HorizontalButtonRaw);

const Card = React.forwardRef((props, ref) => {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const featureMoreItems = true;

  const handleClick = (url, type, speech, event, parameters, expect) => {
    if (!ref.clickAllowed()) {
      return;
    }

    if (type === 'speech') {
      context.request(
        context,
        speech, //item.link.product_name + " " + button.label,
        'button'
      );
    } else if (type === 'action_backend') {
      context.request(
        context,
        speech, //item.link.product_name + " " + button.label,
        'button',
        parameters,
        expect
      );
    } else {
      openLink(context, type, url, event);
    }
  };

  let cardList = data.items.map((item, key) => {
    let isSoldOut = false;
    if (item.product_badge) {
      for (let badgeItem of item.product_badge) {
        if (
          badgeItem.key === 'badge_soldout' ||
          badgeItem.key === 'badge_discontinued' ||
          badgeItem.key === 'badge_not_for_sale'
        ) {
          isSoldOut = true;
        }
      }
    }
    return (
      <div key={`cardList${key}`} className={classes.listitem}>
        <div className={classes.card}>
          <div className={classes.badge}>
            <div className={classes.badgeBox}>
              {item.product_badge &&
                item.product_badge.length > 0 &&
                item.product_badge.map((badgeItem, badgeIndex) => {
                  let badgeTypeClass = '';
                  if (badgeItem.key === 'badge_best') {
                    badgeTypeClass = classes.badgeItemRed;
                  } else if (badgeItem.key === 'badge_new') {
                    badgeTypeClass = classes.badgeItemPupple;
                  } else if (
                    badgeItem.key === 'badge_fastdelivery' ||
                    badgeItem.key === 'badge_ready_for_sale'
                  ) {
                    badgeTypeClass = classes.badgeItemGreen;
                  } else if (isSoldOut) {
                    badgeTypeClass = classes.badgeItemGrey;
                  } else {
                    badgeTypeClass = classes.badgeItemDefault;
                  }
                  return (
                    <div
                      key={`badge_index_${badgeIndex}`}
                      className={`${classes.badgeItem} ${badgeTypeClass}`}
                    >
                      {badgeItem.name}
                    </div>
                  );
                })}
            </div>
          </div>
          <button
            className={classes.thumbnail}
            onClick={() =>
              handleClick(
                item.link['product_link_url'],
                item.link['type'],
                '',
                item.link['event_action']
              )
            }
          >
            <img
              className={classes.thumbnailImage}
              src={item.link['product_image_url']}
              alt={`${item.link['product_title']
                .replace('<sup>', '')
                .replace('</sup>', '')
                .replace('ThinQ', '씽큐')}, ${item.link['product_name']}, 상세 바로가기`}
            />
          </button>
          <div className={classes.info}>
            {/* HTML TAG가 들어간 경우 처리 */}
            <div
              className={classes.infoTitle}
              dangerouslySetInnerHTML={{ __html: item.link['product_title'] }}
              role={'text'}
            />
            <div
              className={classes.infoDescription}
              dangerouslySetInnerHTML={{ __html: item.link['product_name'] }}
            />
            <Divider
              orientation={'horizontal'}
              className={classes.horizontalDivider}
              component={'div'}
              disabled
            />
            <div className={classes.table} size="small">
              {item.product_spec.map((spec, key) => (
                <Fragment key={`spec_${key}`}>
                  <Grid
                    container
                    className={classes.tableRow}
                    key={`product_price${key}`}
                  >
                    <Grid
                      item
                      xs={5}
                      className={classes.label}
                      dangerouslySetInnerHTML={{
                        __html: spec.label,
                      }}
                    />
                    <Grid
                      item
                      xs={7}
                      className={classes.value}
                      dangerouslySetInnerHTML={{
                        __html: spec.value,
                      }}
                    />
                  </Grid>
                </Fragment>
              ))}
            </div>
            {item.product_spec && item.product_spec.length > 0 && (
              <Divider
                orientation={'horizontal'}
                className={classes.horizontalDivider}
                component={'div'}
                disabled
              />
            )}
            {item.product_price && item.product_price.product_master_price !== '0' && (
              <Fragment>
                <div className={classes.priceBox} size="small">
                  <Grid
                    container
                    className={classes.priceRow}
                    key={`product_price${key}`}
                  >
                    {item.product_price.product_obs_price &&
                    item.product_price.product_obs_price !== '0' ? (
                      <>
                        <Grid
                          item
                          className={`${classes.discountRate} ${
                            isSoldOut && classes.discountRateDisable
                          }`}
                          dangerouslySetInnerHTML={{
                            __html: item.product_price.product_sales_percent,
                          }}
                          aria-label={`할인율: ${item.product_price.product_sales_percent}`}
                          role="text"
                        />
                        <Grid
                          item
                          className={[
                            classes.priceObs,
                            isSoldOut && classes.priceObsNA,
                          ].join(' ')}
                          dangerouslySetInnerHTML={{
                            __html: item.product_price.product_obs_price + '원',
                          }}
                          aria-label={`할인가: ${item.product_price.product_obs_price}원`}
                          role="text"
                        />
                        <Grid
                          item
                          className={classes.priceMaster}
                          dangerouslySetInnerHTML={{
                            __html: item.product_price.product_master_price + '원',
                          }}
                          aria-label={`정상가: ${item.product_price.product_master_price}원`}
                          role="text"
                        />
                      </>
                    ) : (
                      <>
                        <Grid
                          item
                          className={[
                            classes.priceObs,
                            isSoldOut && classes.priceObsNA,
                          ].join(' ')}
                          dangerouslySetInnerHTML={{
                            __html: item.product_price.product_master_price + '원',
                          }}
                          aria-label={`정상가: ${item.product_price.product_master_price}원`}
                          role="text"
                        />
                      </>
                    )}
                  </Grid>

                  {item.product_price.max_benefit_price && (
                    <Grid container>
                      <Grid
                        item
                        className={classes.maxBenefitPrice}
                        dangerouslySetInnerHTML={{
                          __html: `최대혜택가 ${Number(
                            item.product_price.max_benefit_price.replaceAll(',', '')
                          ).toLocaleString('ko-KR')}원`,
                        }}
                      />
                    </Grid>
                  )}

                  {/* {item.product_price.benefits &&item.product_price.benefits.label&&(
                    <div className={classes.benefitsRow}>
                      <div className={classes.benefitsText}>{item.product_price.benefits.label}</div>
                      {item.product_price.benefits.url&&(
                        <button 
                          className={classes.benefitsInfoButton} 
                          onClick={()=>{
                            handleClick(item.product_price.benefits.url, item.product_price.benefits.type)
                          }}
                        />
                      )}
                    </div>
                  )} */}
                </div>
              </Fragment>
            )}
          </div>
          <Divider
            orientation={'horizontal'}
            className={classes.horizontalDivider}
            component={'div'}
            disabled
          />
          <MidButton data={item} handleClick={handleClick} />
          {item.horizontal_buttons && (
            <HorizontalButton data={item} handleClick={handleClick} />
          )}

          {/* {item.product_badge && item.product_badge.length > 0 && (
          <div className={classes.badge}>
            <img className={classes.badgeIcon} src={IconBadge} alt={"Badge"} />
            {item.product_badge.map((badgeItem, badgeIndex)=>(<span key={`badge_index_${badgeIndex}`} className={classes.badgeTitle}>{badgeItem.name}</span>))}
          </div>
        )} */}
        </div>
      </div>
    );
  });
  if (featureMoreItems && data.more_items && data.more_items.enable === 'Y') {
    let moreitem_button = (
      <div className={classes.moreItemList}>
        <button
          className={classes.moreItemCard}
          onClick={() => handleClick(data.more_items.url, data.more_items.type)}
        >
          <div className={classes.moreItemThumbnailImage} />
          <div className={classes.moreItemText}>
            {context.string.chat.moreItemHomepage.split('\n').map((content, index) => (
              <Fragment key={`moreItem${index}`}>
                <span>{content}</span>
                <br />
              </Fragment>
            ))}
          </div>
        </button>
      </div>
    );
    cardList.push(moreitem_button);
  }
  return cardList;
});

function ProductCard(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);

  return (
    <>
      <div className={classes.root}>
        <Carousel
          className={classes.carousel}
          component={withStyles(styles)(Card)}
          data={data}
          ariaLabel={context.string.aria.product}
        />
      </div>
    </>
  );
}
export default withStyles(styles)(ProductCard);
